
import config from "@/api/config";
import urlName from "@/api/urlName";
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import { message } from "ant-design-vue";
import { defineComponent, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import routerName from "@/router/routerName";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "CustomerCreate",
  setup() {
    const { t } = useI18n();

    const router = useRouter();
    const route = useRoute();
    const action = config.baseUrl.BASE_JAVA_URL + urlName.image_upload;
    const isEdit = route.query.isEdit as string;
    const user_id = route.query.id as string;
    const uploadData = ref({
      orgId: user_id ? user_id : "1",
    });
    const costomerForm = ref({
      id: "",
      organizationName: "",
      extension: {
        type: 1,
        location: "",
        url: [],
      },
      remark: "",
      createTime: "",
      owner: sessionStorage.getItem("username"),
    });
    const previewVisible = ref(false);
    const previewImage = ref("");
    const previewTitle = ref("");
    const fileList = ref([]) as any;
    const options = [
      { label: t("exclusivestake"), value: 1 },
      { label: t("sharedstake"), value: 2 },
      { label: t("offlinepile"), value: 0 },
    ];
    function getBase64(file: File) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }
    const resetForm = () => {
      router.go(-1);
    };
    const createCustomerParam = () => {
      const photos = new Array<any>();
      fileList.value?.forEach((file: any) => {
        photos.push(file.originFileObj);
      });
      const params = {
        organizationName: costomerForm.value.organizationName,
        remark: costomerForm.value.remark,
        extension: JSON.stringify(costomerForm.value.extension),
        owner: costomerForm.value.owner ? costomerForm.value.owner : "",
        photos: photos,
      };
      return params;
    };

    const addUserF = () => {
      Api.addCustomer(createCustomerParam()).then((val) => {
        if (val.err_no == ResultCodeType.success_200) {
          message.success(t("added"));
          resetForm();
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const editUserF = () => {
      let params = {
        organizationName: costomerForm.value.organizationName,
        remark: costomerForm.value.remark,
        extension: JSON.stringify(costomerForm.value.extension),
        id: Number(user_id),
        owner: costomerForm.value.owner,
      };
      Api.editCustomer(params).then((val) => {
        if (val.err_no == ResultCodeType.success_200) {
          message.success(t("edited"));
          resetForm();
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const submitForm = () => {
      costomerForm.value.organizationName =
        costomerForm.value.organizationName.trim();
      costomerForm.value.extension.location =
        costomerForm.value.extension.location.trim();
      if (costomerForm.value.organizationName.length == 0) {
        message.error(t("customernamecannotbeemptyorblank"));
        return;
      }
      if (costomerForm.value.extension.location.length == 0) {
        message.error(t("customeraddresscannotbeemptyorblank"));
        return;
      }
      if (isEdit) {
        editUserF();
      } else {
        addUserF();
      }
    };
    const onBeforeUploadImage = (file: any) => {
      const isIMAGE =
        file.type == "image/jpg" ||
        file.type == "image/png" ||
        file.type == "image/jpeg";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        message.error(t("thesizeoftheuploadedfilecannotexceed1mb"));
      }
      if (!isIMAGE) {
        message.error(t("theimagemustbeinjpgorpngformat"));
      }
      return isIMAGE && isLt1M;
    };
    const checkCanAdd = (file: any) => {
      if (file.file.status === "done") {
        const canUpload = onBeforeUploadImage(file.file);
        if (!canUpload) {
          if (fileList.value?.length > 0) {
            fileList.value.pop();
          }
        }
      }
    };

    const imgFileChange = (file: any) => {
      checkCanAdd(file);
      if (
        file.file.status === "done" &&
        file.file.response.err_no === ResultCodeType.success_200 &&
        isEdit
      ) {
        costomerForm.value.extension.url =
          costomerForm.value.extension.url.concat(file.file.response.result);
      }
    };

    const removeImg = (file: any) => {
      costomerForm.value?.extension?.url?.some((val, i) => {
        if (`https://${val}` === file?.url) {
          costomerForm.value?.extension?.url?.splice(i, 1);
          return true;
        } else {
          return false;
        }
      });
    };
    const handleCancel = () => {
      previewVisible.value = false;
      previewTitle.value = "";
    };
    const handlePreview = async (file: any) => {
      if (!file.url && !file.preview) {
        file.preview = (await getBase64(file.originFileObj)) as string;
      }
      previewImage.value = file.url || file.preview;
      previewVisible.value = true;
      previewTitle.value =
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1);
    };
    let flag = false;
    const handleChange = (val: any, len: number) => {
      if (val.length < len) {
        flag = false;
      }
      if (flag) {
        return;
      }
      if (val.length >= len) {
        message.error(t("inputonly") + `${len}` + t("character"));
        flag = true;
      }
    };
    const getuserdetailF = () => {
      const param = {
        id: user_id,
      };
      Api.getCustomerDetails(param).then((val) => {
        costomerForm.value.id = val.result[0].id.toString();
        costomerForm.value.organizationName = val.result[0].organizationName;
        costomerForm.value.extension = JSON.parse(val.result[0].extension);
        costomerForm.value.remark = val.result[0].remark;
        if (
          costomerForm.value?.extension?.url &&
          costomerForm.value?.extension?.url?.length > 0
        ) {
          costomerForm.value?.extension?.url?.forEach((val: string) => {
            const data = {
              url: `https://${val}`,
            };
            fileList.value.push(data);
          });
        }
      });
    };
    const labelCol = {
      style: {
        "min-width": "120px",
        "text-align": "left",
      },
    };
    onMounted(() => {
      if (isEdit) {
        getuserdetailF();
        costomerForm.value.id = user_id;
      }
    });
    return {
      action,
      uploadData,
      costomerForm,
      fileList,
      previewVisible,
      previewImage,
      previewTitle,
      removeImg,
      handleCancel,
      handlePreview,
      imgFileChange,
      submitForm,
      handleChange,
      resetForm,
      isEdit,
      options,
      labelCol,
      routerName,
      t,
    };
  },
});
